import React, { useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import API_URL from '../config';
import { getAuthToken } from '../utils/authSession';
import './ContactMessage.css';

// Kort berichtje sturen naar SmartStays vanuit het profielmenu, zonder de app
// te verlaten. Bewust apart van de openbare offerte-aanvraagpagina (/contact):
// dit is voor een al ingelogde gebruiker die gewoon iets wil melden/vragen.
// "initialMessage" laat de aanroeper (bv. ProfileMenu's "Account laten
// verwijderen"-knop) het tekstveld al vooraf invullen met een sjabloontekst,
// zodat de gebruiker niet zelf hoeft te verwoorden waarvoor dit bericht dient
// - hij/zij kan de tekst nog altijd aanvullen/aanpassen voor het versturen.
function ContactMessage({ onClose, initialMessage = '' }) {
  const { t } = useTranslation();
  const [message, setMessage] = useState(initialMessage);
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!message.trim()) {
      setError(t('contactMessage.fillMessage'));
      return;
    }
    setError('');
    setSending(true);
    try {
      const token = getAuthToken();
      await axios.post(`${API_URL}/api/support-message`, { message: message.trim() }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.error || t('contactMessage.sendError'));
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="contactmsg-overlay" onClick={onClose}>
      <div className="contactmsg-modal" onClick={(e) => e.stopPropagation()}>
        <div className="contactmsg-header">
          <button type="button" className="native-detail-back legal-modal-back" onClick={onClose} aria-label={t('common.back')}>
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M15 6l-6 6 6 6" /></svg>
          </button>
          <h2>{t('contactMessage.title')}</h2>
          <button className="contactmsg-close" onClick={onClose}>&times;</button>
        </div>
        <div className="contactmsg-body">
          {sent ? (
            <>
              <p className="contactmsg-success">{t('contactMessage.sent')}</p>
              <button className="contactmsg-submit" onClick={onClose}>{t('common.close', 'Sluiten')}</button>
            </>
          ) : (
            <form onSubmit={handleSubmit}>
              <p className="contactmsg-intro">{t('contactMessage.intro')}</p>
              <textarea
                rows="5"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder={t('contactMessage.placeholder')}
                maxLength="1000"
              />
              <div className="contactmsg-counter">{message.length}/1000</div>
              {error && <div className="contactmsg-error">{error}</div>}
              <button type="submit" className="contactmsg-submit" disabled={sending}>
                {sending ? t('common.loading') : t('contactMessage.send')}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}

export default ContactMessage;
